export function getYears(startYear) {
  var currentYear = new Date().getFullYear();
  return Array.from(Array(currentYear - startYear + 1).keys()).map(year => startYear + year);
}
export var years = getYears(new Date().getFullYear() - 100);